/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Logs} from "../../APIClient.jsx";
import ChartBase from "../Charts/ChartBase.jsx";
import {Util} from "../../Utilities.js";
import Kpi from "../Charts/KPI.jsx";

class NodeCharts extends Component {
    constructor() {
        super();

        this.state = {
            timeline: []
        }
    }

    async fetchData() {
        let {nodeId} = this.props
        let logs = await Logs.getNodeLogs(nodeId, "systemUsage")

        let rows = (logs?.logs ?? [])
        let timeline = rows.map(row => {
            let [date, line] = row.log.split("\t")
            return Util.objects.tryParse(line)
        })
        // remove invalid rows
        timeline = timeline.filter(item => (item !== false))
        timeline = timeline.sort((a, b) => (a.timestamp - b.timestamp))

        this.setState({timeline: timeline})

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.nodeId !== prevProps.nodeId) {
            this.fetchData()
        }
    }

    componentDidMount() {
        this.fetchData()

        this.interval = setInterval(() => {
            this.fetchData()

        }, 10000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }


    render() {
        const {timeline} = this.state;

        const last = timeline.at(-1)

        const cpuPercent = Math.round(last?.cpuPercent ?? 0);
        const memPercent = Math.round(last?.memoryPercent ?? 0);
        const spacePercent = Math.round(last?.spacePercent ?? 0);

        return (
            <div className="space-y-8">
                <dl className="grid grid-cols-1 gap-5 sm:grid-cols-3">
                    <Kpi title="CPU Usage" value={cpuPercent} unit={"%"} className={"text-indigo-500!"}/>
                    <Kpi title="Memory Usage" value={memPercent} unit={"%"} className={"text-emerald-500!"}/>
                    <Kpi title="Disk Usage" value={spacePercent} unit={"%"} className={"text-red-500!"}/>
                </dl>

                <ChartBase
                    titel="CPU 1-min Load"
                    unit="%"
                    max={100}
                    color="rgb(99, 102, 241)"
                    data={timeline.map(t => ({x: t.timestamp * 1000, y: t.cpuPercent}))}
                />

                <ChartBase
                    titel="Memory Usage"
                    unit="%"
                    max={100}
                    color="rgb(16, 185, 129)"
                    data={timeline.map(t => ({x: t.timestamp * 1000, y: t.memoryPercent}))}
                />

                <ChartBase
                    titel="Disk Usage"
                    unit="%"
                    max={100}
                    color="rgb(239, 68, 68)"
                    data={timeline.map(t => ({x: t.timestamp * 1000, y: t.spacePercent}))}
                />
            </div>
        );

    }
}

NodeCharts.propTypes = {};

NodeCharts.defaultProps = {};


export default NodeCharts;